import { useState, useEffect, useCallback, useContext } from "react";
import { AccountCircle, Close, ExitToAppOutlined, SyncAlt, AddToQueueRounded, Person, EventAvailableRounded } from "@material-ui/icons";
import { Fade, Box, MenuItem, Menu, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { signout, esd_storage, is_Admin, ResultObj } from "../../js/Domain";
import { DDMenu_codelist, valueIsValid } from "../../js/api";
import { ConfirmDialogTS } from "../../_AAA/components/ReactDialogTS";
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize } from "../../js/types";
import { ThemeSetContext } from "../ThemeSet";
import { MainPageDialogContext } from "../../js/MainPageDialogContext";
import { useReportApi } from "../../js/adapter/ReportAdapter";
import { CustomDate } from "../../utils/date/dateExtension";
import PunchCardFirstModalInnerPunchCard from "../../_AAA/control/Humanresources/PunchCard/PunchCardFirst/PunchCardFirstModalInnerPunchCard";
import RouterMenuModalSimulateUser from "./RouterMenuModalSimulateUser";

enum ModalName {
    MODAL_LOGOUT = "MODAL_LOGOUT",
    MODAL_SIMULATE_USER = "MODAL_SIMULATE_USER",
    MODAL_PUNCH_CARD = "MODAL_PUNCH_CARD",
}

interface ModalState {
    [ModalName.MODAL_LOGOUT]: boolean;
    [ModalName.MODAL_SIMULATE_USER]: boolean;
    [ModalName.MODAL_PUNCH_CARD]: boolean;
}

interface ResWorkClock {
    time_to: string;
    time_off: string;
}

interface RouterMenuProps {
    navRes: {
        children: Array<{ code: string; name: string }>;
    };
    hasPunchCard?: boolean;
}

const RouterMenu = ({ navRes, hasPunchCard }: RouterMenuProps) => {
    const { themeColor } = useContext(ThemeSetContext);
    const { responseMessage } = useContext(MainPageDialogContext);
    const reportApiManager = useReportApi();
    const history = useHistory();

    const [userName] = useState<string>(esd_storage.name);
    const [plant, setPlant] = useState<string>("尚無綁定廠別");
    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [resWorkClock, setResWorkClock] = useState<ResWorkClock>({ time_to: "", time_off: "" });
    const [modalState, setModalState] = useState<ModalState>({
        [ModalName.MODAL_LOGOUT]: false,
        [ModalName.MODAL_SIMULATE_USER]: false,
        [ModalName.MODAL_PUNCH_CARD]: false,
    });

    const setModalOpen = (modalName: ModalName, open: boolean) => {
        setModalState(prev => ({ ...prev, [modalName]: open }));
    };

    useEffect(() => {
        const init = async () => {
            const position_Id = sessionStorage.getItem("Plant") ?? "";
            const menuLists = await DDMenu_codelist;
            const posList = menuLists.codeList_POS;
            const matched = position_Id !== "" ? posList.find(item => item.sps_id === position_Id) : null;
            setPlant(matched ? matched.name : "尚無綁定廠別");

            if (!reportApiManager) return;
            try {
                const today = new CustomDate().toYYYYMMDD();
                const res = await reportApiManager.WorkClockRecordStatistic({
                    date_start: today,
                    date_end: today,
                    user_ids: [esd_storage.user_id],
                });
                if (res.data && res.data.length > 0) {
                    setResWorkClock({
                        time_to: res.data[0].time_to,
                        time_off: res.data[0].time_off,
                    });
                }
            } catch (error) {
                responseMessage(error as ResultObj);
            }
        };
        init();
    }, [reportApiManager]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setMenuOpen(prev => !prev);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => setMenuOpen(false);

    const handleBlur = () => setMenuOpen(false);

    const logout = useCallback(() => {
        const layoutType_Left = localStorage.getItem("layoutType_Left");
        const layoutType_Right = localStorage.getItem("layoutType_Right");
        signout().then(() => {
            sessionStorage.clear();
            localStorage.clear();
            history.push("/Login");
            window.location.reload();
        }).then(() => {
            if (layoutType_Left) localStorage.setItem("layoutType_Left", layoutType_Left);
            if (layoutType_Right) localStorage.setItem("layoutType_Right", layoutType_Right);
        });
    }, [history]);

    const navHandleClick = (e: React.MouseEvent<HTMLLIElement>) => {
        sessionStorage.home_page_name = e.currentTarget.innerText;
        const menuBtn = e.currentTarget.getAttribute("data-menu");
        if (menuBtn !== sessionStorage.home_page) {
            sessionStorage.home_page = menuBtn;
            history.push("/Index/Home");
            window.location.reload();
        }
    };

    const userHandleClick = () => {
        sessionStorage.home_page_name = "系統後台";
        sessionStorage.home_page = "Dashboard";
        window.history.pushState({ page: "UserInformationFirst" }, "", "/UserInformation/UserInformationFirst");
        window.location.reload();
    };

    const resWorkClockColor =
        valueIsValid(resWorkClock.time_to) && !valueIsValid(resWorkClock.time_off)
            ? themeColor.secondary
            : valueIsValid(resWorkClock.time_to) && valueIsValid(resWorkClock.time_off)
                ? themeColor.error
                : themeColor.primary;

    return (
        <>
            <div style={{ marginLeft: "auto" }}>
                <div style={{ display: "flex" }}>
                    <Button
                        aria-controls="fade-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        style={{ color: "#fff" }}
                    >
                        <AccountCircle
                            style={{ fontSize: "1.2rem", color: resWorkClockColor, background: "#fafafa", borderRadius: "10px" }}
                            fontSize="large"
                        />&nbsp;&nbsp;{plant + " - " + userName}
                    </Button>
                </div>
                <Menu
                    open={menuOpen}
                    keepMounted
                    TransitionComponent={Fade}
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    onBlur={handleBlur}
                >
                    <Box display={{ xs: "block", sm: "block", md: "none" }}>
                        <div className="menuTitle middle">系統</div>
                        {navRes.children.map((item, index) => {
                            const selected = item.code === sessionStorage.home_page;
                            return (
                                <MenuItem
                                    key={index}
                                    data-menu={item.code}
                                    selected={selected}
                                    onClick={navHandleClick}
                                >
                                    <SyncAlt style={{ fontSize: "1rem" }} />&nbsp;{item.name}
                                </MenuItem>
                            );
                        })}
                    </Box>
                    <div className="menuTitle middle">設定</div>
                    {is_Admin() && (
                        <MenuItem
                            data-menu="user"
                            onClick={() => { setMenuOpen(false); setModalOpen(ModalName.MODAL_SIMULATE_USER, true); }}
                        >
                            <AddToQueueRounded style={{ fontSize: "1rem" }} />&nbsp;模擬使用者
                        </MenuItem>
                    )}
                    <MenuItem data-menu="user" onClick={userHandleClick}>
                        <Person style={{ fontSize: "1rem" }} />&nbsp;使用者資訊
                    </MenuItem>
                    {hasPunchCard && (
                        <MenuItem
                            data-menu="punchCard"
                            onClick={() => { setMenuOpen(false); setModalOpen(ModalName.MODAL_PUNCH_CARD, true); }}
                        >
                            <EventAvailableRounded style={{ fontSize: "1rem" }} />&nbsp;打卡&nbsp;:&nbsp;
                            {valueIsValid(resWorkClock.time_to) && !valueIsValid(resWorkClock.time_off)
                                ? <span style={{ color: themeColor.primary }}>上班</span>
                                : valueIsValid(resWorkClock.time_to) && valueIsValid(resWorkClock.time_off)
                                    ? <span style={{ color: themeColor.error }}>下班</span>
                                    : <span style={{ color: themeColor.secondary }}>未打卡</span>
                            }
                        </MenuItem>
                    )}
                    <MenuItem
                        data-menu="exit"
                        onClick={() => { setMenuOpen(false); setModalOpen(ModalName.MODAL_LOGOUT, true); }}
                    >
                        <ExitToAppOutlined style={{ fontSize: "1rem" }} />&nbsp;登出
                    </MenuItem>
                    <MenuItem data-menu="close" onClick={handleClose}>
                        <Close style={{ fontSize: "1rem" }} />&nbsp;關閉
                    </MenuItem>
                </Menu>
            </div>

            {modalState[ModalName.MODAL_LOGOUT] && (
                <ConfirmDialogTS
                    modalOpen={true}
                    closeClick={() => setModalOpen(ModalName.MODAL_LOGOUT, false)}
                    modal={{
                        id: "logoutModal",
                        modaltitle: "登出",
                        size: ConfirmDialogPropsSize.XS,
                        scroll: ConfirmDialogPropsScroll.BODY,
                        messages: "確認要登出嗎？",
                        modalAction: logout,
                    }}
                />
            )}

            {modalState[ModalName.MODAL_SIMULATE_USER] && (
                <RouterMenuModalSimulateUser
                    modalClose={() => setModalOpen(ModalName.MODAL_SIMULATE_USER, false)}
                />
            )}

            {modalState[ModalName.MODAL_PUNCH_CARD] && (
                <PunchCardFirstModalInnerPunchCard
                    loadingTopLayer={true}
                    modalConfirm={() => setModalOpen(ModalName.MODAL_PUNCH_CARD, false)}
                    modalClose={() => setModalOpen(ModalName.MODAL_PUNCH_CARD, false)}
                />
            )}
        </>
    );
};

export default RouterMenu;
